import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useDeviceCheck } from "hooks";

export const GSAPAnimationMedia = ({
  onScreenAnimation,
  children,
  className = "",
}) => {
  const ref = useRef(null);
  const { isMobile } = useDeviceCheck();

  useEffect(() => {
    if (onScreenAnimation) {
      gsap.registerPlugin(ScrollTrigger);
      switch (onScreenAnimation) {
        case "extension":
          onExtension();
          break;
        case "scale":
          onScale();
          break;
        case "parallax":
          onParallax();
          break;
        default:
          break;
      }
    }
  }, []); //eslint-disable-line

  const onExtension = () => {
    gsap.fromTo(
      ref.current,
      { scale: 0.7 },
      {
        scale: 1,
        ease: ".5, .35, .15, 1.00",
        scrollTrigger: {
          trigger: ref?.current,
          start: "top bottom",
          end: "center center",
          toggleActions: "play none none reverse",
        },
      }
    );
  };

  const onScale = () => {
    gsap.fromTo(
      ref.current,
      { scale: 0.95 },
      {
        scale: 1,
        ease: ".5, .35, .15, 1.00",
        scrollTrigger: {
          trigger: ref?.current,
          start: "top bottom-=30%",
          toggleActions: "play none none reverse",
        },
      }
    );
  };

  const onParallax = () => {
    gsap.set(ref.current, { position: "absolute", top: 0 });
    gsap.to(ref.current, {
      scrollTrigger: {
        trigger: ref.current,
        start: "top 90%",
        end: isMobile ? "+=390 top" : "+=792 top",
        scrub: 1,
        toggleActions: "play none reverse none",
      },
      top: isMobile ? `-${110}px` : `-${130}px`,
      ease: "none",
    });
  };

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};

GSAPAnimationMedia.propTypes = {
  onScreenAnimation: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};
